import { makeEnum } from "../../utils/enumUtils.js";

// ============================================
// USER-SPECIFIC ENUMS
// ============================================

// User languages
export const { ENUM: USER_LANGUAGES, VALUES: USER_LANGUAGE_VALUES } = makeEnum({
  ENGLISH: "en",
  ARABIC: "ar",
});

// User themes
export const { ENUM: USER_THEMES, VALUES: USER_THEME_VALUES } = makeEnum({
  LIGHT: "LIGHT",
  DARK: "DARK",
  SYSTEM: "SYSTEM",
});

// Time formats
export const { ENUM: TIME_FORMATS, VALUES: TIME_FORMAT_VALUES } = makeEnum({
  H12: "H12",
  H24: "H24",
});

// Device types
export const { ENUM: DEVICE_TYPES, VALUES: DEVICE_TYPE_VALUES } = makeEnum({
  MOBILE: "MOBILE",
  TABLET: "TABLET",
  DESKTOP: "DESKTOP",
});
